module.exports = __webpack_public_path__ + "static/media/global-preferences-network.82ca6e33.svg";